import { action, makeObservable } from 'mobx';
import { getEnv } from 'mobx-easy';

import BaseDomainStore from './base-domain-store';
import { RootEnv } from '../root-env';

abstract class BaseDomainObject<T> {
	protected entityName;
	abstract id: number;
	abstract get asJson(): Partial<T>;

	protected store;

	// TODO: make all stores u BaseDomainStore
	protected constructor(store: BaseDomainStore<T> | any, entityName: string) {
		makeObservable(this, {
			set: action
		});

		this.store = store;
		this.entityName = entityName;
	}

	set(domainObject: Partial<T> | Partial<BaseDomainObject<T>>) {
		Object.assign(this, domainObject);
	}

	create = async (json: Partial<T>) => {
		const { id } = await getEnv<RootEnv>().dashboardSdk.sdk[this.entityName].create(json);
		this.id = id;
		this.store.set(this);
	};

	async update(json: Partial<T>, options = {}) {
		const response = await getEnv<RootEnv>().dashboardSdk.sdk[this.entityName].update(
			Object.assign({}, json, options)
		);

		this.set({ ...this.asJson, ...response });
		this.store.set(this);
	}

	delete = async (...args: any[]) => {
		await getEnv<RootEnv>().dashboardSdk.sdk[this.entityName].delete(this.id, ...args);
		this.store.remove(this.id);
	};
}

export default BaseDomainObject;
